export const CategoryType = {
  hotel: 'hotel',
  pension: 'pension',
  residence: 'residence',
  motel: 'motel',
  guesthouse: 'guesthouse',
  global: 'global',
  transportation: 'transportation',
  leisure: 'leisure',
  kids: 'kids',
  entertainment: 'entertainment',
  live: 'live',
} as const;

export type Category = keyof typeof CategoryType;
